
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-slate-900">
              Eng. João Paulo Scardelato Severino
            </h1>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-slate-700 hover:text-slate-900 cursor-pointer"
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-slate-700 hover:text-slate-900 cursor-pointer"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-slate-700 hover:text-slate-900 cursor-pointer"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('como-trabalho')}
              className="text-slate-700 hover:text-slate-900 cursor-pointer"
            >
              Como Trabalho
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-slate-700 hover:text-slate-900 cursor-pointer"
            >
              Contato
            </button>
          </nav>

          <div className="hidden md:flex">
            <Button onClick={() => scrollToSection('contato')}>
              Solicitar Orçamento
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-slate-700 hover:text-slate-900 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <button
                onClick={() => scrollToSection('inicio')}
                className="block px-3 py-2 text-slate-700 hover:text-slate-900 cursor-pointer w-full text-left"
              >
                Início
              </button>
              <button
                onClick={() => scrollToSection('sobre')}
                className="block px-3 py-2 text-slate-700 hover:text-slate-900 cursor-pointer w-full text-left"
              >
                Sobre
              </button>
              <button
                onClick={() => scrollToSection('servicos')}
                className="block px-3 py-2 text-slate-700 hover:text-slate-900 cursor-pointer w-full text-left"
              >
                Serviços
              </button>
              <button
                onClick={() => scrollToSection('como-trabalho')}
                className="block px-3 py-2 text-slate-700 hover:text-slate-900 cursor-pointer w-full text-left"
              >
                Como Trabalho
              </button>
              <button
                onClick={() => scrollToSection('contato')}
                className="block px-3 py-2 text-slate-700 hover:text-slate-900 cursor-pointer w-full text-left"
              >
                Contato
              </button>
              <div className="px-3 py-2">
                <Button onClick={() => scrollToSection('contato')}>
                  Solicitar Orçamento
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
